// extracted by mini-css-extract-plugin
export default {"box":"FilterCity_box__Shkbs","input":"FilterCity_input__9njeZ","boxLoading":"FilterCity_boxLoading__qSGMo"};